import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeButton,
	XThemeInputText,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { Row, Col, Button, Input, notification, Space } from 'antd';
import { XCardsProfileBg } from '../Profile/ProfileStyle';
// actions
import {
	changePasswordApi,
	changePasswordReset,
} from '../../actions/changePasswordAction';
import { handleInputChange } from '../../utils/formFunctions';
import Header from '../../components/Header/Header';
import {
	XTheme2Button
} from '../../styles/GlobalThemeStyleCQ';
const ChangePassword = (props) => {
	const { changePassword, changePasswordReset, changePasswordState } = props;
	const navigate = useNavigate();
	const [form] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});

	// use effects
	useEffect(() => {
		if (changePasswordState.apiState === 'success') {
			notification.success({ message: changePasswordState.message });
			changePasswordReset();
			form.resetFields();
		} else if (changePasswordState.apiState === 'error') {
			notification.error({ message: changePasswordState.message });
			changePasswordReset();
		}
	}, [changePasswordState]);
	return (
		<>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header headerTag="Reset Password" />
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile />
				</Col>
			</>
			<XThemeContainer fluid>
				<XThemeDetailsCards className="noBGMobile largePadding mb-3">
					<XThemeForm
						form={form}
						name="loginForm"
						layout="vertical"
						autoComplete="off"
						onFinish={() => changePassword(formData)}
					>
						<Row>
							<Col
								xs={{ span: 24, offset: 0 }}
								sm={{ span: 24, offset: 0 }}
								lg={{ span: 8, offset: 8 }}
							>
								<Row gutter={[15, 15]}>
									<Col xs={24}>
										<XThemeForm.Item
											className="drawerlabelBold"
											name="password"
											label="Old Password"
											rules={[
												{
													required: true,
													message:
														'Please enter your old password',
												},
											]}
										>
											<XThemeInputText
												className="largeInputForms"
												size="large"
												placeholder="Enter your old password"
												name="password"
												type="password"
												onChange={(e) =>
													handleInputChange(
														e,
														formData,
														setFormData,
													)
												}
											/>
										</XThemeForm.Item>
									</Col>
									<Col xs={24}>
										<XThemeForm.Item
											className="drawerlabelBold"
											name="new_password"
											label="New Password"
											rules={[
												{
													required: true,
													message:
														'Please input your password!',
												},
												{
													min: 8,
													message:
														'Password must be at least 8 characters long!',
												},
												{
													pattern:
														/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
													message:
														'Password must include at least one letter, one number, and one special character!',
												},
											]}
										>
											<XThemeInputText
												className="largeInputForms"
												size="large"
												placeholder="Enter your password"
												name="new_password"
												type="password"
												onChange={(e) =>
													handleInputChange(
														e,
														formData,
														setFormData,
													)
												}
											/>
										</XThemeForm.Item>
									</Col>
									<Col xs={24}>
										<XThemeForm.Item
											className="drawerlabelBold"
											name="confirm_password"
											label="Confirm New Password"
											dependencies={['new_password']}
											hasFeedback
											rules={[
												{
													required: true,
													message:
														'Please confirm your new password',
												},
												({ getFieldValue }) => ({
													validator(_, value) {
														if (
															!value ||
															getFieldValue(
																'new_password',
															) == value
														) {
															return Promise.resolve();
														}
														return Promise.reject(
															new Error(
																'The two passwords that you entered do not match!',
															),
														);
													},
												}),
											]}
										>
											<XThemeInputText
												className="largeInputForms"
												size="large"
												placeholder="Confirm new password"
												name="confirm_password"
												type="password"
												onChange={(e) =>
													handleInputChange(
														e,
														formData,
														setFormData,
													)
												}
											/>
										</XThemeForm.Item>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row gutter={[15, 15]} className="mt-3">
							<Col xs={24} className="text-center">
								<Space>
									<XTheme2Button
										size="large"
										className="backgroundRevers px-5 px-sm-4"
										onClick={() => navigate(-1)}
									>
										Cancel
									</XTheme2Button>
									<XTheme2Button
										size="large"
										className="px-5 px-sm-4"
										htmlType="submit"
										type="primary"
									>
										Submit
									</XTheme2Button>
								</Space>
							</Col>
						</Row>
					</XThemeForm>
				</XThemeDetailsCards>
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	changePasswordState: state.changePassword,
});

const mapDispatchToProps = (dispatch) => ({
	changePassword: (data) => dispatch(changePasswordApi(data)),
	changePasswordReset: () => dispatch(changePasswordReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
